import * as API from 'api'
import * as Store from 'store'
import { httpRequest } from './initialize'
import { Operation } from '.';

/** Indicate if user information was loaded */
export const isLoaded = ({ user }: Store.IRootState) => {
    return (user && user.name !== '');
}

/** Indicate if user has active subscription  */
export const hasSubscriptions = ({ user }: Store.IRootState): boolean => {
    return user && user.subscriptions && user.subscriptions.length > 0;
}

/** Active Subscriptions  */
export const getSubscriptions = ({ user }: Store.IRootState) => {
    return (user && user.subscriptions) ? user.subscriptions : [];
}

/** Display Name  */
export const displayName = ({ user }: Store.IRootState) => {
    return (user && user.name) ? user.name : '';
}


/** Indicate if user has active subscription  */
export const isPendingEmailConfirmation = ({ user }: Store.IRootState): boolean => {
    return user && user.isPendingEmail === true;
}

/** Load user information  */
export const loadUserInformation = (dispatch) => {
    dispatch(Store.User.userInfoLoading());
    return API.User.fetchUserInfo(httpRequest)
        .then(userData => {
            //ToDo: refactor on server
            const subscriptions = userData.activeSubscriptionId ? [userData.activeSubscriptionId] : [];
            dispatch(Store.User.userInfoSuccess({ id: userData.id, name: userData.displayName, isPendingEmail: userData.isPendingEmailConfirmation, subscriptions, email: userData.email }));
            return userData;
        }).catch((err) => {
            Operation.onFail('Failed to load user account information', dispatch, err)
            dispatch(Store.User.userInfoFail(err))
            //If we fail to load user => then logout (no point loading application)
            dispatch(Store.Authentication.logout());
        });
}



// WEBPACK FOOTER //
// ./src/application/user.ts